export default "__VITE_ASSET__280f2826__"